import React, { useState } from 'react'
import './FAQ.css'
import FAQData from './FAQData';

const FAQ = () => {
    const [selected, setSelected] = useState(null);

    const toggle = (i) => {
        if(selected == i){
            setSelected(null);
        }else{
            setSelected(i);
        }
    }

  return (
    <div className='faq-container'>
        <h2>FAQs</h2>
        {FAQData.map((item, i) => (
            <div className='faq' key={i} >
                <div className='question' onClick={()=>toggle(i)}>
                    <h3>{item.question}</h3>
                    <svg className={selected === i ? 'svg svg-active' : 'svg'} width="15" height="10" viewBox='0 0 42 25'>
                        <path d="M3 3L21 21L39 3" stroke='white' strokeWidth="7" strokeLinecap="round" />
                    </svg>
                </div>
                <div className={selected === i ? 'answer active' : 'answer'}>
                    <p>{item.answer}</p>
                </div>
            </div>
        ))}
    </div>
  )
}

export default FAQ